<template>
    <main class="SectionCookies-MAIN">
        <img src="../assets/arrow-back.png" @click="$router.push('/');"/>
        <h1>Configuración de cookies</h1>
        <hr>
        <p>
            Esta sección regula las finaldiades de las cookies. Active o desactive según prefiera. Para más detalles, consulte la <span @click="goToPrivacy()">Política Privacidad.</span>
        </p>

        <label>
            <div>
                <b>Necesarias</b>
                <p>Requeridas para funcionalidad básica</p>
            </div>
            <div class="switch">
                <label class="cookies-switch cookies-switch-lock"> <input type="checkbox" checked disabled/> <img src="../assets/lock.png"/> </label>
            </div>
        </label>
        <label>
            <div>
                <b>Preferencias</b>
                <p>Recuerdan las selecciones del usuario. No afectan el rendimiento.</p>
            </div>
            <div class="switch">
                <label class="cookies-switch"> <input type="checkbox" v-model="preferences"/> <div></div> </label>
            </div>
        </label>
        <label>
            <div>
                <b>Estadísticas</b>
                <p>Recopilan datos anónimos sobre el tráfico para mejorar la experiencia del usuario.</p>
            </div>
            <div class="switch">
                <label class="cookies-switch"> <input type="checkbox" v-model="statistics"/> <div></div> </label>
            </div>
        </label>

        <button @click="saveCookies()">GUARDAR</button>
    </main>
</template>

<script>
export default {
    name: 'SectionCookies',
    data(){
        return{
            preferences: false,
            statistics: false,
        }
    },
    methods: {
        goToPrivacy(){
            this.$router.push({ name: 'privacy' });
        },

        saveCookies(){
            const cookies = {
                preferences: this.preferences,
                statistics: this.statistics,
            };
            localStorage.setItem('apart-cookies', JSON.stringify(cookies));
            this.$router.push('/');
        }
    }
}
</script>

<style scoped lang="stylus">
.SectionCookies-MAIN
    display: flex
    flex-direction: column
    padding: 10px
    width: calc(100% - 20px)
    min-height: calc(100vh - 20px)
    background-color: white

    >img
        width: 8vw
        margin-bottom: 2vw

    >h1
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        font-size: 12vw
        text-wrap: balance
        margin-bottom: 0

    >hr
        width: 100%
        border: 1px solid black

    >p
        font-family: "Archivo ExtraCondensed", sans-serif
        margin-top: 0
        font-size: 6vw
        color: #B0B0B0
        margin-bottom: 8vh

        >span
            color: black
            text-decoration: underline

     >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace
        border: none

    /* inputs */
    >label
        display: flex
        align-items: center
        justify-content: space-between
        border-bottom: 1px solid #C3C3C3
        margin-bottom: 2vh
        padding-bottom: 1vw

        >div

            &:first-child
                font-family: "Archivo ExtraCondensed", sans-serif
                max-width: 75%

                b
                    font-size: 6vw
                    text-transform: uppercase

                p
                    margin: 0
                    font-size: 5.5vw
                    color: #C3C3C3

.cookies-switch
    height: 20px
    width: 40px
    background-color: var(--switch-bg)
    border-radius: 100vw
    display: flex
    align-items: center
    position: relative
    cursor: pointer
    background-color: gray

    input
        display: none

    >div
        width: 14px
        aspect-ratio: 1/1
        border-radius: 100vw
        background-color: white
        position: absolute
        left: 3px
        transition: left 0.1s, background-color 0.1s

    input:checked + div
        left: calc(100% - 14px - 3px)
        background-color: white

.cookies-switch:has(input:checked)
   background-color: #1E88E5

.cookies-switch-lock
    display: flex
    align-items: center
    justify-content: center

    >img
        max-height: 80%
</style>